/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef } from "react";
import {
  I2cRadioButton,
  I2cRadioGroup,
  I2cFileUpload,
  I2cDatePicker,
  I2cIcon,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import FilesUploadService from "../../../Services/FilesUploadService";
import { useMutation } from "react-query";
const SSRP = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const nightlyFiles = ["Yes", "No","N/A"];
  const Manual = useRef(null); 

const optionalString = Yup.string().optional();

 const validationSchema = Yup.object({

  ov_nf_ssrp_for_manager: optionalString,

  ov_nf_cut_off_time: optionalString,

  ov_nf_pci_compliant: optionalString,

  ov_nf_comp_cert: Yup.string().test(
    "compliance-cert",
    "Compliance certificate is required.",
    function (val) {
      const pci = this.parent.ov_nf_pci_compliant;

      if (pci === "yes") {
        return !val || val.length > 0;
      }

      return true;
    }
  ),

});
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      ov_nf_ssrp_for_manager: "",
      ov_nf_cut_off_time: "12:00 AM",
      ov_nf_pci_compliant: "",
      ov_nf_comp_cert: "",
    },
  });
  const formData = new FormData();

  const handleFileUpload = async (name) => {
    try {
      formData.append("file", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (name) => {
      return await FilesUploadService.uploadFile(name);
    },
    onSuccess: (data) => {
      methods.setValue("ov_nf_comp_cert", data?.data?.url);
      methods.trigger();
      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  const downloadFile = async (fileName) => {
    try {
      await fileDownload.mutate(fileName);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileDownload = useMutation({
    mutationFn: async (fileName) => {
      return await FilesUploadService.downloadFile(fileName);
    },
    onSuccess: (data) => {
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";

      // Set the download attribute with the file name
      // link.setAttribute('download', fileName);

      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "ov_nf_ssrp_for_manager",
    "ov_nf_cut_off_time",
    "ov_nf_pci_compliant",
    "ov_nf_comp_cert",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      const normalizedValues = {};
      fields.forEach((field) => {
        let value = formDataJson[8]["8_0"][field] ?? "";
        if (field === "ov_nf_cut_off_time" && typeof value === "string") {
          // Convert 24h HH:MM:SS or HH:MM to 12h AM/PM format
          const match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
          if (match) {
            const hours24 = parseInt(match[1], 10);
            const minutes = match[2];
            const ampm = hours24 >= 12 ? "PM" : "AM";
            const hours12 = hours24 % 12 || 12;
            value = `${String(hours12).padStart(2, "0")}:${minutes} ${ampm}`;
          }
          if (!value) value = "12:00 AM";
        }
        methods.setValue(field, value);
        normalizedValues[field] = value;
      });
      methods.trigger();
      setAddFormData((prev) => ({
        ...prev,
        8: {
          ...prev["8"],
          "8_0": { ...normalizedValues },
        },
      }));
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    // Strip seconds from cut-off time if saved in HH:MM:SS format
    if (typeof values.ov_nf_cut_off_time === "string") {
      values.ov_nf_cut_off_time = values.ov_nf_cut_off_time.replace(
        /^(\d{1,2}:\d{2}):\d{2}$/,
        "$1"
      );
    }
    setAddFormData({
      ...addFormData,
      8: {
        ...addFormData["8"],
        "8_0": { ...values },
      },
    });
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("8_0", true);
    else setFormValidStates("8_0", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <div className="sub-heading mb-16">
            Would you require SSRP nightly files from i2c Inc?
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="ov_nf_ssrp_for_manager"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("ov_nf_ssrp_for_manager")}
                  {...field}
                  name="ov_nf_ssrp_for_manager"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {nightlyFiles.map((radio, index) => (
                    <I2cRadioButton
                      key={index}
                      value={radio.toLocaleLowerCase()}
                    >
                      {radio}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
          </div>
        </div>
        <div className="halfWidth section-space">
          <div className="sub-heading mb-16">Preferred Cut Off Time</div>
           <div i2c-grid="grid gap-sm" className="mt-16">
                  <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
            <Controller
              name="ov_nf_cut_off_time"
              control={control}
              render={({ field }) => (
                <I2cDatePicker
                  className="datePicker0"
                  dateFormat="h:i K"
                  enableTime
                  errorMessageInvisible={true}
                  minuteIncrement={1}
                  rotateIcon
                  hoist
                  placeholder="Select Time"
                  noCalendar
                  size="large"
                  onI2cDateApply={(e) => {
                    if (e.target.appliedDate.length === 0) {
                      field.onChange("12:00 AM");
                    } else if (e.target?.appliedDate) {
                      const date = e.target.appliedDate[0];
                      const hours24 = date.getHours();
                      const minutes = date.getMinutes();
                      const ampm = hours24 >= 12 ? "PM" : "AM";
                      const hours12 = hours24 % 12 || 12;
                      const value = `${String(hours12).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${ampm}`;
                      field.onChange(value);
                    } else field.onChange("");
                    handleValueChanges();
                  }}
                  defaultDate={
                    methods.watch("ov_nf_cut_off_time") ??
                    methods.watch("ov_nf_cut_off_time")
                  }
                />
              )}
            />
            <ErrorMessage
              show={
                errors.ov_nf_cut_off_time &&
                methods.formState.touchedFields.ov_nf_cut_off_time
                  ? true
                  : false
              }
              message={errors.ov_nf_cut_off_time?.message ?? "Invalid input"}
            />
          </div>
          </div>
          </div>
        </div>
        <div>
          <div className="sub-heading mb-16">Are you PCI Compliant?</div>
          <div className="single-field-wrapper">
            <Controller
              name="ov_nf_pci_compliant"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("ov_nf_pci_compliant")}
                  {...field}
                  name="ov_nf_pci_compliant"
                  onI2cChange={(e) => {
                    if (e.target.value === "no") {
                      methods.setValue("ov_nf_comp_cert", "");
                    }
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {nightlyFiles.map((radio, index) => (
                    <I2cRadioButton
                      key={index}
                      value={radio.toLocaleLowerCase()}
                    >
                      {radio}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
          </div>
        </div>
        <div className="mt-16">
          {methods.watch("ov_nf_pci_compliant") === "yes" && (
            <>
              <div>
                <div className="mb-16 custom-label-light">
                  Please upload PCI Compliance certificate.
                </div>
                <I2cFileUpload
                  ref={Manual}
                  autoProcessQueue={false}
                  no-mobile-controls
                  max-files={1}
                  className="customFileUpload"
                  setAcceptedFiles=".pdf"
                  icon="linear-document-upload"
                  label="Click to upload"
                  caption="or drag and drop"
                  name="ov_nf_comp_cert"
                  message="Only PDF file (max. 5MB)."
                  onI2cFileRemoved={(e) => {
                    methods.setValue("ov_nf_comp_cert", "");
                    methods.trigger();
                    handleValueChanges();
                  }}
                  onI2cAddedFile={(e) => {
                    handleFileUpload(
                      Manual.current.getDropZone().files[
                        Manual.current.getDropZone().files.length - 1
                      ],
                    );
                  }}
                />
              </div>
              {Object.keys(formDataJson ?? {}).length ? (
                <>
                  {formDataJson[8]?.["8_0"]?.ov_nf_comp_cert !== null && (
                    <div className="mt-16">
                      <I2cButton
                        size="small"
                        variant="link color"
                        className=""
                        onClick={() => {
                          downloadFile(formDataJson[8]?.["8_0"]?.ov_nf_comp_cert);
                        }}
                      >
                        <I2cIcon
                          slot="prefix"
                          name="linear-document-download"
                          label="add"
                        ></I2cIcon>{" "}
                        Download File
                      </I2cButton>
                    </div>
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SSRP;
